<template>
    <div class="app-calendar" :style="`grid-template-columns: repeat(${dayMap.length}, 1fr);`" role="table" aria-label="Weekly menu calendar">
        <div class="app-calendar-header-row">
            <div v-for="(day, day_index) in dayMap" :key="'header-' + day_index" class="app-calendar-day-title" role="columnheader" :aria-label="'Menu for ' + day">{{ day }}</div>
        </div>
        
        <div v-if="Object.keys(categories).length == 0" v-for="(day, day_index) in days" :key="'empty-' + day_index" class="app-calendar-empty-day-cell" :aria-label="'No menu scheduled for this day for ' + dayMap[day_index]">
            {{ day.NonOperatingPeriodName || 'No menu scheduled for this day' }} 
        </div>
        
        <div v-for="(category, index) in Object.values(categories)" :key="'cat-row-' + index" class="app-calendar-category-row" role="group" :aria-label="category.CategoryName + ' category row'">
            <div v-for="(day, day_index) in days" :key="'cat-' + index + '-day-' + day_index"
                 :style="{
                     'grid-column': day_index + 1,
                     'grid-row': !day.HasMenuItems && index == 0 ? `${index + 2} / span ${Object.keys(categories).length}` : index + 2,
                     'display': !day.HasMenuItems && index > 0 ? 'none' : 'flex'
                 }"
                 :class="!day.HasMenuItems && index == 0 ? 'app-calendar-empty-day-cell' : 'app-calendar-day-cell'"
                 role="group" 
                 :aria-label="!day.HasMenuItems ? 'No menu scheduled for this day for ' + dayMap[day_index] : category.CategoryName + ' for ' + dayMap[day_index]">
                
                <div v-if="!day.HasMenuItems && index == 0">
                    {{ day.NonOperatingPeriodName || 'No menu scheduled for this day' }}
                </div>
                <div v-else-if="day.HasMenuItems">
                    <div class="app-calendar-category-title" role="heading"><b>{{ category.CategoryName }}</b></div>
                        <ul v-if="category.MenuItemsByDay[day_index + 1] && category.MenuItemsByDay[day_index + 1].MenuItems.length" class="app-calendar-item-list" role="list" :aria-label="category.CategoryName + ' menu items for ' + dayMap[day_index]">
                            <li v-for="(item, iIdx) in category.MenuItemsByDay[day_index + 1].MenuItems" :key="iIdx">
                                <button
                                    v-if="!item.IsPlaceholder"
                                    :id="'app-subject-' + day_index + '-' + item.Name.replaceAll(' ', '-') + '-' + iIdx"
                                    :data-day-number="day_index"
                                    @click="openMenuItemDetails(item.MenuItemId)"
                                    class="app-calendar-item"
                                    :aria-label="item.Name + ', ' + category.CategoryName + ' for ' + dayMap[day_index] + '. Click for details.'"
                                >
                                    {{ item.Name }}
                                </button>
                                <span v-else class="app-calendar-item-text-only">{{ item.Name }}</span>
                            </li>
                        </ul>
                    <div v-else class="app-calendar-empty-day-cell" :aria-label="'No ' + category.CategoryName + ' items for ' + dayMap[day_index]">None</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
    name: 'DesktopCalendar',
    components: {
        'fragment': Fragment
    },
    props: {
        days: {
            type: Array,
            required: true
        },
        dayMap: {
            type: Array,
            required: true
        },
        categories: {
            type: Object,
            required: true
        }
    },
    methods: {
        openMenuItemDetails(menuItemId) {
            this.$emit('menu-item-selected', menuItemId);
        }
    }
}
</script>